import { Button } from '@flowus/common/components';
import { message } from '@flowus/common/components/message';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { useOpenModal } from '@flowus/common/next-modal';
import { Regex } from '@flowus/login/utils';
import CryptoJS from 'crypto-js';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { FormInput } from 'src/common/components/input';
import { useUpdateUserSetting } from '../helper';

export const useOpenAccountPin = () => {
  const { t } = useAppTranslation();
  const openModal = useOpenModal();
  const { handleSubmit, register } = useForm<{ pin: string }>();
  const updateUserSetting = useUpdateUserSetting();
  return useCallback(() => {
    openModal.modal({
      content: (_) => (
        <form
          className="p-5 space-y-5 text-t1-medium w-72"
          onSubmit={handleSubmit(async (e) => {
            if (!Regex.VerifyCode.test(e.pin)) {
              message.error(t('components.account_setting.pin_format_error'));
              return;
            }
            await updateUserSetting({
              pin: CryptoJS.MD5(e.pin).toString(),
            });
            message.success(t('common.set_success'));
            _.onCloseModal();
          })}
        >
          <div>{t('components.account_setting.setup_pin')}</div>
          <FormInput
            inputProps={register('pin', { required: true })}
            autoFocus
            className="h-8 textSecurity"
            maxLength={6}
            placeholder={t('components.account_setting.enter_6_digit')}
          />
          <Button colorType="active">{t('common.done')}</Button>
        </form>
      ),
    });
  }, [handleSubmit, openModal, register, updateUserSetting, t]);
};
